import { defineStore } from 'pinia'
import { StyleProvider, Themes } from '@varlet/ui'

export const useThemeStore = defineStore('theme', {
    state: () => ({
        // 主题对象，初始用 md3Dark 转 viewport 版本
        themeName: "dark" //Themes.toViewport(Themes.md3Dark)
    }),
    getters: {
        getThemeName(state): "dark" | "light" {
            return state.themeName as any;
        }
    },
    persist: true,
    actions: {
        /**
         * 切换主题（示例：传入 Themes.md3Light 或 md3Dark）
         * @param themeObject 
         */
        setTheme(themeName: "dark" | "light") {
            this.themeName = themeName;
            switch (themeName) {
                case "dark":

                    StyleProvider({
                        ...Themes.md3Dark,
                        // floatingPanelZIndex: 20000,
                        // bottomNavigationFabBorderRadius: '0',
                        // bottomNavigationHeight:'180px'
                    });
                    break;
                case "light":
                    StyleProvider({
                        ...Themes.md3Light,
                        // floatingPanelZIndex: 20000,
                        // bottomNavigationHeight:'180px'
                        // bottomNavigationFabBorderRadius: '0',
                    });
                    break;
            }
        }
    }
})
